module.exports = __webpack_public_path__ + "img/insurance.edbc97d2.svg";